import styled from "@emotion/styled";
import { Table } from "@mui/joy";
import { styled as muiStyled } from "@mui/joy/styles";
import { createLink, Link } from "@tanstack/react-router";

export const StyledTable = muiStyled(Table, {
  shouldForwardProp: (prop) => prop !== "rowHeight" && prop !== "isLongTotal",
})<{ rowHeight: number; isLongTotal: boolean }>(({ theme, rowHeight, isLongTotal }) => ({
  width: "max-content",
  touchAction: "none",
  "tbody tr th, tbody tr td": {
    borderBottom: "1px solid",
    borderBottomColor: "var(--TableCell-borderColor)",
  },
  "th, td": {
    borderRight: "1px solid",
    borderRightColor: "var(--TableCell-borderColor)",
    display: "flex",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  "thead th": {
    whiteSpace: "normal",
    overflow: "visible",
    height: "auto",
    alignItems: "flex-end",
  },
  "thead th a": {
    display: "flex",
  },
  "thead tr": {
    alignItems: "stretch",
  },
  "th.position, td.position": {
    width: 100,
    justifyContent: "flex-end",
  },
  "td.position": {
    fontWeight: "bold",
  },
  "td.total": {
    fontWeight: "bold",
    justifyContent: "flex-end",
  },
  "th.competitor": {
    width: 250,
  },
  "th.round, td.round": {
    width: 130,
  },
  "th.total, td.total": {
    width: isLongTotal ? 150 : 120,
  },
  "tbody tr td, tbody tr th": {
    height: `${rowHeight}px`,
  },
  thead: {
    backgroundColor: "white",
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  "thead th.round, thead th.total": {
    justifyContent: "flex-end",
    textAlign: "right",
  },
  tr: {
    display: "flex",
    flexDirection: "row",
  },
}));

export const CompetititorCellStyled = createLink(styled(Link)`
  text-decoration: none;
  color: inherit;
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  min-width: 0;
  div.right {
    flex: 1;
    overflow: hidden;
  }
  div.user {
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
    p {
      font-size: 1rem;
      margin: 0;
    }
    text-overflow: ellipsis;
  }
  div.category {
    font-weight: normal;
    font-size: 0.8rem;
  }
`);

export const RoundScoreCellStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 1;
  .score {
    font-weight: bold;
  }

  .position {
    font-size: 0.85rem;
    color: var(--joy-palette-neutral-600);
  }
`;

export const EmptyCell = styled.div`
  flex: 1;
  background-color: var(--joy-palette-neutral-100);
  margin: -4px -8px;
`;
